import { IActivityConfiguration } from 'app/authoring/interfaces/IActivityComponent';
import { Metamodel } from 'app/model/base/model';
import { ActivityConfigurations } from 'app/authoring/registries/activity-configurations';

import { SwitchActivity } from 'app/model/pipeline/switch.activity';
import { Pipeline } from 'app/model/pipeline/pipeline';
import { getActivityUrl } from 'app/shared/utils/links.util';

@ActivityConfigurations.register({})
export class SwitchActivityConfiguration implements IActivityConfiguration {
    public label = stringResources.SwitchActivityLabel;
    public name = 'Switch';
    public activityType = Metamodel.modelFor(SwitchActivity);
    public iconClass = 'svg-i_switch_16x16';
    public iconTransform = '';
    public categories = [stringResources.Activity_Category_Iteration];
    public supportedInTrident = true;
    public isKnownInPipelineContext = true;
    public docLink = getActivityUrl('switch');

    public getDefaultMappingProperty(switchActivity: SwitchActivity): Pipeline | undefined {
        return switchActivity.defaultPipeline;
    }

    public setMappingProperty(switchActivity: SwitchActivity, defaultActivitiesPipeline: Pipeline): void {
        switchActivity.defaultPipeline = defaultActivitiesPipeline;
    }
}
